import axios from 'axios'

const DispatchingService = {
  async get (params = {}) {
    return axios.get('lo/delivery-dispatchings', { params })
  },

  async histories (params = {}) {
    return axios.get('lo/reports/delivery-dispatching-histories', { params })
  },

  async show (id) {
    return axios.get(`lo/delivery-dispatchings/${id}`)
  },

  async post (params = {}) {
    return axios.post('lo/delivery-dispatchings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`lo/delivery-dispatchings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`lo/delivery-dispatchings/${data.id}`, { data })
  }
}

export default DispatchingService
